import * as React from "react";
import { UserInfo } from "../userInfo";
import { ClinicOnboardView } from "./clinicOnboardView";
import { ClinicActionButton } from "fe-web-components/clinic/clinicActionButton";
import { clearLastSelectedClinicId } from "../clinicManage";
import { getCurrentUserEmail } from "@kahunmedical/user-management";
import { useEffect } from "react";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicNoAccessProps {
  resetClinic: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicNoAccess = ({ ...props }: ClinicNoAccessProps) => {
  useEffect(() => {
    getCurrentUserEmail().then(clearLastSelectedClinicId);
  }, []);

  return (
    <ClinicOnboardView
      title="Sorry, you can't access this clinic"
      footerContent={
        <ClinicActionButton
          label="Go to your default clinic"
          onClick={() => props.resetClinic()}
        />
      }
    >
      <UserInfo className={"absolute"} />
      <div style={{ textAlign: "center" }}>
        You do not have permission to sign in to this clinic
      </div>
    </ClinicOnboardView>
  );
};
